import UTDService from '../services/UTDService';

export const SITE_BASE_URL = UTDService.getBaseUrl() || "https://www.erwedding.be";